<template>
    <div class="flex items-center gap-2">
        <AuditTimestamp :date="props.data.created_at"></AuditTimestamp>
        <img
            :src="props.data.user_avatar"
            :alt="props.data.user_name"
            class="w-4 h-4 rounded-full aspect-square"
            onerror="this.onerror=null;this.src='/default-images/avatar.png';this.style.backgroundImage = 'none';"
        />
        {{ props.data.user_name }} created a play in
        <a :href="`/plays/show?playId=${details.play_id}`"
            >{{ props.data.playbook_title }}/{{ details.play_name }} play</a
        >
    </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
const props = defineProps(["data"]);
const details = computed(() => JSON.parse(props.data.details));
</script>
